"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1699))
 * @trackcomponent
 * @lastsynced 2025-04-11T14:43:35.168Z
 * @optimized using svgo:^3.0.2
 */
export const PaymentPlan = createSVGIcon(
  <>
    <path
      d="M12 7.714V5.143M12 16.286v2.571M9.429 14.572c0 1.285 1.152 1.714 2.571 1.714s2.572 0 2.572-1.715c0-2.57-5.143-2.57-5.143-5.142 0-1.715 1.152-1.715 2.571-1.715s2.572.65 2.572 1.715M18.857 15.429l3.429-.858.857 3.429"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.286 14.571A11.31 11.31 0 0 1 12 22.286a10.32 10.32 0 0 1-9.663-6.772M5.143 8.571l-3.429.858L.857 6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.714 9.429A11.63 11.63 0 0 1 12 1.714a10.32 10.32 0 0 1 9.664 6.772"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "PaymentPlan",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
